<template>
  <div class="money-page">
    <h3 class="page-title">{{ $t("withdraw.withdraw_form") }}</h3>

    <section class="balance-card">
      <span class="muted">{{ $t("withdraw.user_balance") }}</span>
      <div class="balance-value">
        <b>{{ Number($store.state.amount).toLocaleString() }}</b>
        <span>Unit</span>
      </div>
    </section>

    <section class="form-card">
      <label>{{ $t("withdraw.choose_payment_type") }}</label>
      <AccountSelect
        :data="selected_account"
        field="account_id"
        :accounts="accounts"
      />
      <span class="error">{{ errors.account }}</span>

      <label>{{ $t("withdraw.account_number") }}</label>
      <input
        type="number"
        class="form-control"
        v-model="withdrawData.account_number"
      />
      <span class="error">{{ errors.number }}</span>

      <label>{{ $t("withdraw.enter_amount") }}</label>
      <small>{{ $t("withdraw.minimum_deposit") }}</small>
      <input
        type="number"
        class="form-control"
        v-model="withdrawData.amount"
      />
      <span class="error">{{ errors.amount }}</span>

      <label>{{ $t("withdraw.remark") }}</label>
      <textarea
        rows="3"
        class="form-control"
        v-model="withdrawData.remark"
      ></textarea>

      <button type="button" class="submit-btn" @click="onSubmit">
        <span v-if="!isConfirm">{{ $t("withdraw.submit") }}</span>
        <Loading color="#1a1408" v-if="isConfirm" size="22" />
      </button>
    </section>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from "vant";
import { mapActions } from "vuex";
import AccountSelect from "./components/AccountSelect.vue";

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      accounts: [
        {
          name: "KBZ pay",
          id: "KBZ pay",
          link: "https://cdn.gold549.com/build/assets/img/payments/kpay.png",
        },
        {
          name: "KBZ Mobile Banking",
          id: "KBZ Mobile Banking",
          link: "https://cdn.gold549.com/build/assets/img/payments/kbz.png",
        },
        {
          name: "Wave pay",
          id: "Wave pay",
          link: "https://cdn.gold549.com/build/assets/img/payments/wavepay.png",
        },
        {
          name: "CB Pay",
          id: "CB Pay",
          link: "https://cdn.gold549.com/build/assets/img/payments/cb_pay.png",
        },
        {
          name: "CB Banking",
          id: "CB Banking",
          link: "https://cdn.gold549.com/build/assets/img/payments/cbbank.png",
        },
        {
          name: "AYA Pay",
          id: "AYA Pay",
          link: "https://cdn.gold549.com/build/assets/img/payments/ayapay.png",
        },
        {
          name: "AYA Banking",
          id: "AYA Banking",
          link: "https://cdn.gold549.com/build/assets/img/payments/aya.png",
        },
        {
          name: "Yoma Banking",
          id: "Yoma Banking",
          link: "https://cdn.gold549.com/build/assets/img/payments/aya.png",
        },
      ],
      account: [],
      withdrawData: {},
      errors: {},
      isConfirm: false,
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    onSubmit() {
      this.$playSound();
      this.sendWithdrawData();
    },
    async sendWithdrawData() {
      try {
        const authUser = await this.fetchUser();
        this.errors = {};
        if (!this.selected_account.account_id) {
          this.errors.account = this.$t("withdraw.enter_account_type");
          return false;
        }
        if (!this.withdrawData.account_number) {
          this.errors.number = this.$t("withdraw.enter_account_number");
          return false;
        }
        if (!this.withdrawData.amount) {
          this.errors.amount = this.$t("withdraw.enter_amount");
          return false;
        }
        if (this.withdrawData.amount < 10000) {
          this.errors.amount = this.$t("withdraw.enter_at_least");
          return false;
        }
        if (this.withdrawData.amount > authUser.amount) {
          Dialog.alert({
            message: this.$t("withdraw.insufficient_balance"),
            confirmButtonText: this.$t("withdraw.go_back"),
          }).then(() => {});
          return false;
        }
        if (this.isConfirm) {
          return false;
        }
        this.$store.commit(
          "setAmount",
          (this.$store.state.amount -= this.withdrawData.amount)
        );
        this.isConfirm = true;
        if (this.imageUploader[0]) {
          this.withdrawData.transaction_image = this.imageUploader[0].content;
        }
        this.withdrawData.type = this.selected_account.account_id;
        this.withdrawData.date = this.currentTime;
        await axios.post("/withdraws", this.withdrawData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        await axios.post(
          `/admin/user/${this.$store.state.authUser.id}`,
          {
            amount: this.withdrawData.amount,
            type: "withdraw",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        this.imageUploader = [];
        this.withdrawData = {};
        this.selected_account.account_id = null;
        Toast.success("Success");
        this.isConfirm = false;
      } catch (error) {
        this.isConfirm = false;
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require("moment-timezone");
      const dateInTimeZone = moment.tz(new Date(), "Asia/Rangoon");
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();
      return new Date(year, month, day, hour, minute, second, millisecond);
    },
  },
  computed: {
    currentTime() {
      return moment(this.createDateWithTimeZone()).format("lll");
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
  },
};
</script>
<style scoped>
.money-page {
  min-height: 100vh;
  padding: 14px 14px 8rem;
}

.page-title {
  margin-bottom: 12px;
  color: #f0e6c8;
  font-weight: 700;
}

.balance-card,
.form-card {
  background: #1c1c1c;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
}

.balance-card {
  padding: 14px;
  margin-bottom: 12px;
}

.muted {
  display: block;
  font-size: 0.75rem;
  color: #b8b3a8;
}

.balance-value {
  display: flex;
  align-items: baseline;
  gap: 6px;
  color: #f7d56a;
}

.balance-value b {
  font-size: 1.4rem;
}

.form-card {
  padding: 14px;
}

.form-card label {
  display: block;
  margin-top: 10px;
  margin-bottom: 6px;
  color: #f0e6c8;
  font-weight: 600;
}

.form-card label:first-child {
  margin-top: 0;
}

.form-card small {
  display: block;
  margin-bottom: 6px;
  color: #d8c48a;
}

.error {
  display: block;
  min-height: 1em;
  margin-bottom: 4px;
  color: #ff7a59;
  font-size: 0.78rem;
}

.submit-btn {
  width: 100%;
  margin-top: 14px;
  padding: 11px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  font-weight: 700;
}

.form-control {
  margin-bottom: 4px;
}
</style>
